import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { redirectRequireAuthentication } from '#/modules/auth/routing/redirect-require-authentication';
import type { orgDashboardMembershipLinksRoute } from '#/modules/orgDashboard/routing/org-select.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { MembershipLinksLoadable } from './MembershipLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof orgDashboardMembershipLinksRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    MembershipLinksLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });
}

export default function OrgDashboardMembershipLinksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <MembershipLinksLoadable />;
}
